const useGetLanguageListDto = async (
  variables?: GetLanguageListQueryVariables,
  options?: GraphqlQueryOptions<GetLanguageListQuery, GetLanguageListQueryVariables>,
) => {
  const query = await useGraphqlQuery(GetLanguageListSchema, variables, options);
  const list = computed(() => query.result.value?.info?.languages?.list ?? null);

  return {
    ...query,
    list,
  };
};

export { useGetLanguageListDto };
